import React, { useEffect, useState, FC } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { useHistory } from 'react-router-dom';
import { Controller, useForm } from 'react-hook-form';
import { v4 as uuidv4 } from 'uuid';
import * as yup from 'yup';

//Components
import { Button, Col, Container, Form, ListGroup, Row } from 'react-bootstrap';
import ActivityDualList from '../common/ActivityDualList';
import ActivityLoading from '../common/ActivityLoading';
import ActivityToast from '../common/ActivityToast';

//Services
import { getGroups } from '../../services/GroupService';
import { getGroupsOfActivity } from '../../services/NewGroupService';
import { createActivity, getActivityById, updateActivity } from '../../services/ActivityService';
import { getCycles } from '../../services/CycleService';
import { getLocations } from '../../services/LocationService';
import { getTeachers } from '../../services/UserService';

//Types
import { ActivityInterface, CycleInterface, GroupInterface, LocationInterface, ToastOptionsInterface, UserInterface } from '../common/Types';

//Icons
import { FaPlus, FaMinus } from 'react-icons/fa';

const schema = yup.object().shape({
    name: yup.string().required("El campo 'Nombre' es requerido"),
    description: yup.string().required("El campo 'Descripción corta' es requerido"),
    longDescription: yup.string().required("El campo 'Descripción completa' es requerido"),
    // schedule: yup.string().required("El campo 'Horarios' es requerido"),
    direction: yup.string().required("El campo 'Ubicación' es requerido"),
    contact: yup.string().required("El campo 'Responsable' es requerido"),
    specific_instructions: yup.string().required("El campo 'Instrucciones específicas' es requerido"),
    students_limit: yup.number()
        .min(1, "El campo 'Límite de alumnos' debe ser mayor a 0")
        .typeError("El campo 'Límite de alumnos' debe ser un número")
        .required("El campo 'Límite de alumnos' es requerido"),
    cycle: yup.string().required("El campo 'Ciclo escolar' es requerido")
});

const defaultValues: any = {
    name: "",
    description: "",
    longDescription: "",
    schedule: [],
    direction: "",
    contact: "",
    specific_instructions: "",
    students_limit: 0,
    reserved: 0,
    inscribed: 0,
    cycle: "",
};

interface GroupListInterface {
    available: Array<GroupInterface>,
    selected: Array<GroupInterface>
}

const ScheduleComponent: FC<any> = (props: any) => {
    const { schedule, setValue } = props;

    const [day, setDay] = useState("Monday");
    const [startTime, setStartTime] = useState();
    const [endTime, setEndTime] = useState();

    const saveSchedule = () => {
        const scheduleList = [...schedule];
        if (schedule?.length > 0) {
            const scheduleFound = scheduleList.find((sch: string) => sch === `${day}, ${startTime}-${endTime}`);
            if (scheduleFound) return;

            scheduleList.push(`${day}, ${startTime}-${endTime}`);
            setValue(scheduleList)
        } else {
            setValue([`${day}, ${startTime}-${endTime}`])
        }
    }

    const deleteSchedule = (schRemove: string) => {
        const scheduleList = [...schedule];
        const scheduleFiltered = scheduleList.filter((sch: string) => sch !== schRemove);

        setValue(scheduleFiltered)
    }

    return (
        <div style={{ marginBottom: '10px' }}>
            <Row xs={1} md={4}>
                <Form.Group >
                    <Form.Label>Día</Form.Label>
                    <select required className="select-input" onChange={(e) => setDay(e.target.value)}>
                        <option key={`direction-0`} disabled value="">Selecciona uno...</option>
                        {["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"].map((item: any, key: any) => (
                            <option key={`day-${key + 1}`} value={item}>{item}</option>
                        ))}
                    </select>
                </Form.Group>
                <Form.Group onChange={(e: any) => setStartTime(e.target.value)} controlId="cycleName">
                    <Form.Label>Hora inicio</Form.Label>
                    <Form.Control
                        type="time"
                    />
                </Form.Group>
                <Form.Group onChange={(e: any) => setEndTime(e.target.value)} controlId="cycleName">
                    <Form.Label>Hora fin</Form.Label>
                    <Form.Control
                        type="time"
                    />
                </Form.Group>
                <Form.Group >
                    <Form.Label></Form.Label>
                    <div>
                        <Button disabled={!day || !startTime || !endTime} variant="primary" aria-label="save" onClick={saveSchedule}>
                            <FaPlus />
                        </Button>
                    </div>
                </Form.Group>
            </Row>
            {schedule && <ListGroup>
                {schedule.map((sch: string, idx: number) =>
                    <Row key={idx}>
                        <Col>
                            <ListGroup.Item>{sch}</ListGroup.Item></Col>
                        <Col xs={1}>
                            <Button variant="primary" aria-label="save" onClick={() => deleteSchedule(sch)}>
                                <FaMinus />
                            </Button>
                        </Col>
                    </Row>
                )}
            </ListGroup>}
        </div>
    )
}

const Activity: FC = (props: any) => {
    const { location } = props;

    const [action, setAction] = useState("create");
    const [loading, setLoading] = useState(false);
    const [activity, setActivity] = useState<ActivityInterface | undefined>(undefined);
    const [schedule, setSchedule] = useState<Array<string>>([]);
    const [imageFile, setImageFile] = useState<any>();
    const [cycles, setCycles] = useState<Array<CycleInterface>>([]);
    const [locations, setLocations] = useState<Array<LocationInterface>>([]);
    const [usersAdmin, setUsersAdmin] = useState<Array<UserInterface>>([]);
    const [groupList, setGroupList] = useState<GroupListInterface>({ available: [], selected: [] });
    const [groupsNoActivity, setGroupsNoActivity] = useState<Array<GroupInterface> | undefined>(undefined);
    const [groupsByActivity, setGroupsByActivity] = useState<Array<GroupInterface> | undefined>(undefined);
    const [toastOptions, setToastOptions] = useState<ToastOptionsInterface>({ open: false, message: "" });

    const history = useHistory();

    const { control, formState, handleSubmit, setValue } = useForm({
        mode: 'onChange',
        defaultValues,
        resolver: yupResolver(schema)
    });
    const { errors } = formState;

    useEffect(() => {
        setLoading(true);
        fetchData();
    }, [])

    useEffect(() => {
        setLoading(true);

        const locationSplit = location.pathname.split('/');

        if (locationSplit[2] === "edit") {
            setAction("update")
            fetchActivity(locationSplit[3]);
        } else {
            const state = location.state ? location.state : undefined;
            if (state !== undefined) {
                delete state.data.id;
                setActivity(state.data as ActivityInterface);
            } else
                setActivity({} as ActivityInterface);
        }

        getGroups().then((response: any) => {
            setGroupsNoActivity(response as Array<GroupInterface>);
        })
    }, [location])

    useEffect(() => {
        if (activity && activity.id) {
            getGroupsOfActivity(activity.id).then((response: any) => {
                setGroupsByActivity(response as Array<GroupInterface>);
            })

            setValue('name', activity.name ? activity.name : "");
            setValue('description', activity.description ? activity.description : "");
            setValue('longDescription', activity.longDescription ? activity.longDescription : "");
            setValue('inscribed', activity.inscribed ? activity.inscribed : 0);
            setValue('schedule', activity.schedule ? activity.schedule : []);
            setValue('direction', activity.direction ? activity.direction : "");
            setValue('contact', activity.contact ? activity.contact : "");
            setValue('specific_instructions', activity.specific_instructions ? activity.specific_instructions : "");
            setValue('students_limit', activity.students_limit ? activity.students_limit : 0);
            setValue('cycle', activity.cycle ? activity.cycle : "");
            setSchedule(activity.schedule ? activity.schedule as Array<string> : [])
        } else if (activity && !activity.id) {
            setValue('name', activity.name ? activity.name : "");
            setValue('description', activity.description ? activity.description : "");
            setValue('longDescription', activity.longDescription ? activity.longDescription : "");
            setValue('inscribed', activity.inscribed ? activity.inscribed : 0);
            setValue('schedule', activity.schedule ? activity.schedule : []);
            setValue('direction', activity.direction ? activity.direction : "");
            setValue('contact', activity.contact ? activity.contact : "");
            setValue('specific_instructions', activity.specific_instructions ? activity.specific_instructions : "");
            setValue('students_limit', activity.students_limit ? activity.students_limit : 0);
            setValue('cycle', activity.cycle ? activity.cycle : "");
            setSchedule(activity.schedule ? activity.schedule as Array<string> : [])
        }
        else {
            setGroupsByActivity([]);
        }
    }, [activity, setValue])


    useEffect(() => {
        if (groupsByActivity && groupsNoActivity) {
            const selected: Array<GroupInterface> = [];
            const available: Array<GroupInterface> = [];

            groupsByActivity.forEach(gByActivity => {
                selected.push({ id: gByActivity.id, name: gByActivity.name })
            });

            groupsNoActivity.forEach(gNoActivity => {
                const inActivity = groupsByActivity.find((gByActivity) => gByActivity.id === gNoActivity.id);

                if (!inActivity)
                    available.push({ id: gNoActivity.id, name: gNoActivity.name })
            });

            setGroupList({ selected, available } as GroupListInterface);
            setLoading(false)
        }
    }, [groupsByActivity, groupsNoActivity])

    const fetchActivity = (activityId: string) => {
        if (!activityId || activityId === "error") {
            setToastOptions({ open: true, message: "Ha ocurrido un error" })
            setLoading(false)
            return;
        }

        getActivityById(activityId).then((response: any) => {
            setActivity(response as ActivityInterface)
        })
    }

    const fetchData = () => {
        getCycles().then((response: any) => {
            response?.sort((a1: any, a2: any) => a1.name.localeCompare(a2.name));
            setCycles(response as Array<CycleInterface>)
        })

        getLocations().then((response: any) => {
            response?.sort((a1: any, a2: any) => a1.name.localeCompare(a2.name));
            setLocations(response as Array<LocationInterface>)
        })

        // getUsersTeacher().then((response: any) => {
        //     setUsersAdmin(response as Array<UserInterface>)
        // })

        getTeachers().then((response: any) => {
            setUsersAdmin(response as Array<UserInterface>)
        })

        setLoading(false);
    }

    const onSubmit = (activityData: ActivityInterface) => {
        setLoading(true)
        const payload: ActivityInterface = {
            name: activityData.name,
            description: activityData.description,
            longDescription: activityData.longDescription,
            schedule: schedule,
            direction: activityData.direction,
            contact: activityData.contact,
            specific_instructions: activityData.specific_instructions,
            students_limit: activityData.students_limit,
            cycle: activityData.cycle,
            inscribed: activityData.inscribed ? activityData.inscribed : 0,
            reserved: activityData.reserved ? activityData.reserved : 0,
            deleted: false
        }

        const addGroupsActivity = groupsByActivity ?
            groupList.selected.filter((ele: GroupInterface) => {
                return !groupsByActivity.find((gba: GroupInterface) => gba.id === ele.id);
            }) :
            groupList.selected.filter((ele: GroupInterface) => ele.id);

        if (action === "update" && activity) {
            const removeGroupsActivity = groupsByActivity ?
                groupList.available.filter((ele: GroupInterface) => {
                    return groupsByActivity.find((gba: GroupInterface) => gba.id === ele.id);
                }) :
                groupList.available.filter((ele: GroupInterface) => ele.id);

            updateActivity(activity.id, payload, imageFile, addGroupsActivity, removeGroupsActivity)
                .then((response: string) => {
                    if (response !== "error") {
                        history.push({ pathname: `/activities` })
                    } else {
                        setToastOptions({ open: true, message: "Ha ocurrido un error" })
                        setLoading(false)
                    }
                });
        } else {
            createActivity(payload, imageFile, addGroupsActivity)
                .then((response: string) => {
                    if (response !== "error") {
                        history.push({ pathname: `/activities` })
                    } else {
                        setToastOptions({ open: true, message: "Ha ocurrido un error" })
                        setLoading(false)
                    }
                });
        }
    }

    const handleFileUpload = (file: any) => {
        if (!file)
            setImageFile(undefined)

        const splitName = file.name.split(".");
        const extension = splitName[splitName.length - 1];
        const name = `${uuidv4()}`;
        const fileName = `${name}.${extension}`;

        setImageFile({ fileName, name, extension, file })
    }

    const handleToastClose = (data: any) => {
        setToastOptions({ open: false, message: "" });
    }

    const handleDualSave = (data: any) => {
        setGroupList(data);
    }

    if (loading)
        return <ActivityLoading />

    return (
        <Container>
            <ActivityToast {...toastOptions} onClose={handleToastClose} autohide={4000} />
            <div style={{ marginBottom: '10px' }}>
                <h1>Actividad</h1>
            </div>
            <Button
                type="submit"
                variant="outline-primary"
                aria-label="save"
                className="return-button"
                onClick={() => history.goBack()}
            >
                {`Regresar`}
            </Button>
            {activity?.image_url &&
                <div>
                    <img height="330px" width="330px" src={activity.image_url} alt="" />
                </div>
            }
            <form className="flex flex-col justify-center w-full" onSubmit={handleSubmit(onSubmit)}>
                <Controller
                    name="name"
                    control={control}
                    render={({ field }) => (
                        <Form.Group controlId="activityName">
                            <Form.Label>Nombre</Form.Label>
                            <Form.Control
                                {...field}
                                isInvalid={!!errors.name}
                                placeholder="Nombre de la actividad..."
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors?.name?.message}
                            </Form.Control.Feedback>
                        </Form.Group>
                    )}
                />
                <Form.Group>
                    <Form.Label>Imagen</Form.Label>
                    <Form.Control
                        type="file"
                        accept="image/png, image/jpeg"
                        name="archivo"
                        onChange={(e: any) => handleFileUpload(e.target.files[0])}
                    />
                </Form.Group>
                <Controller
                    name="description"
                    control={control}
                    render={({ field }) => (
                        <Form.Group controlId="activityName">
                            <Form.Label>Descripción corta</Form.Label>
                            <Form.Control
                                {...field}
                                isInvalid={!!errors.description}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors?.description?.message}
                            </Form.Control.Feedback>
                        </Form.Group>
                    )}
                />
                <Controller
                    name="longDescription"
                    control={control}
                    render={({ field }) => (
                        <Form.Group controlId="activityName">
                            <Form.Label>Descripción larga</Form.Label>
                            <Form.Control
                                {...field}
                                isInvalid={!!errors.longDescription}
                                as="textarea"
                                rows={3}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors?.longDescription?.message}
                            </Form.Control.Feedback>
                        </Form.Group>
                    )}
                />
                <Controller
                    name="direction"
                    control={control}
                    render={({ field }) => (
                        <Form.Group controlId="activityName">
                            <Form.Label>Ubicación</Form.Label>
                            <select required className="select-input" {...field}>
                                <option key={`direction-0`} disabled value="">Selecciona uno...</option>
                                {locations.map((item: any, key: any) => (
                                    <option key={`direction-${key + 1}`} value={item.id}>{item.name}</option>
                                ))}
                            </select>
                        </Form.Group>
                    )}
                />
                <Controller
                    name="contact"
                    control={control}
                    render={({ field }) => (
                        <Form.Group controlId="activityName">
                            <Form.Label>Responsable</Form.Label>
                            <select required className="select-input" {...field}>
                                <option key={`contact-0`} disabled value="">Selecciona uno...</option>
                                {usersAdmin.map((item: any, key: any) => (
                                    <option key={`contact-${key + 1}`} value={item.id}>{item.displayName}</option>
                                ))}
                            </select>
                        </Form.Group>
                    )}
                />
                <Controller
                    name="specific_instructions"
                    control={control}
                    render={({ field }) => (
                        <Form.Group controlId="activityName">
                            <Form.Label>Instrucciones específicas</Form.Label>
                            <Form.Control
                                {...field}
                                isInvalid={!!errors.specific_instructions}
                                as="textarea"
                                rows={3}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors?.specific_instructions?.message}
                            </Form.Control.Feedback>
                        </Form.Group>
                    )}
                />
                <Controller
                    name="students_limit"
                    control={control}
                    render={({ field }) => (
                        <Form.Group controlId="activityName">
                            <Form.Label>Límite de alumnos</Form.Label>
                            <Form.Control
                                {...field}
                                isInvalid={!!errors.students_limit}
                                onChange={(e: any) => setValue('students_limit', e.target.value.replace(/[^0-9]/g, ''))}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors?.students_limit?.message}
                            </Form.Control.Feedback>
                        </Form.Group>
                    )}
                />
                <Controller
                    name="cycle"
                    control={control}
                    render={({ field }) => (
                        <Form.Group controlId="activityName">
                            <Form.Label>Ciclo escolar</Form.Label>
                            <select required className="select-input" {...field}>
                                <option key={`cycle-0`} disabled value="">Selecciona uno...</option>
                                {cycles.map((item: any, key: any) => (
                                    <option key={`cycle-${key + 1}`} value={item.id}>{item.name}</option>
                                ))}
                            </select>
                        </Form.Group>
                    )}
                />

                <Form.Label>Horarios</Form.Label>
                <ScheduleComponent schedule={schedule} setValue={setSchedule} />

                <Form.Label>Grupos</Form.Label>
                <ActivityDualList data={groupList} onSave={handleDualSave} />

                <div style={{ marginBottom: '10px' }}>
                    <Button variant="primary" type="submit" aria-label="save">
                        Guardar actividad
                    </Button>
                </div>
            </form>
        </Container>
    )
}

export default Activity;
